import { render, staticRenderFns } from "./holiday-form.vue?vue&type=template&id=1c05397a&scoped=true&lang=pug&"
import script from "./holiday-form.vue?vue&type=script&lang=ts&"
export * from "./holiday-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05397a",
  null
  
)

export default component.exports